import Cookie from "js-cookie";

// Reads the place ids the logged-in account can see, from the same
// "child_places" cookie fetchLatestKeyarData already reads independently.
// Used to decide how many place-scoped WebSocket connections to open —
// one per place, since the account may have more than one.
export function getMonitoredPlaceIds() {
    try {
        const childPlacesCookie = Cookie.get("child_places");
        if (!childPlacesCookie) return [];
        const places = JSON.parse(childPlacesCookie);
        return places.map((p) => Number(p.id));
    } catch (err) {
        return [];
    }
}
